import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import LineLayer from "../../line";
import PointLayer from "../../point";
import Tile from "./Tile";
export default class DebugTile extends Tile {
  initTileLayer() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const sourceOptions = _this.getSourceOption();
      const pointData = sourceOptions.data.features[0].properties;
      const lineLayer = new LineLayer().source(sourceOptions.data, sourceOptions.options).size(1).shape('line').color('red');
      const pointLayer = new PointLayer({
        minZoom: _this.z - 1,
        maxZoom: _this.z + 1,
        textAllowOverlap: true
      }).source([pointData], {
        parser: {
          type: 'json',
          x: 'x',
          y: 'y'
        }
      }).size(20).color('red').shape(_this.key).style({
        stroke: '#fff',
        strokeWidth: 2
      });
      yield _this.addLayer(lineLayer);
      yield _this.addLayer(pointLayer);
      _this.isLoaded = true;
    })();
  }
  getSourceOption() {
    const rawSource = this.parent.getSource();
    const features = this.sourceTile.data.layers.testTile.features;
    return {
      data: {
        type: 'FeatureCollection',
        features
      },
      options: {
        parser: {
          type: 'geojson'
        },
        transforms: rawSource.transforms
      }
    };
  }
}